import { IRequestAction, progressEpic } from "./base-epic";
import { RECENT_ORDERS } from "constants/action-types";
import siteConfig from "site-config";
import { IV3Order as IOrder } from "constants/order-types";

interface IAction extends IRequestAction {
    removeActiveBrand: boolean;
}

export const fetchRecentOrdersEpic = progressEpic<IAction, IOrder[]>(
    RECENT_ORDERS.FETCH,
    ({ payload }) => ({
        method: "GET",
        url: siteConfig.api + payload.url,
        removeActiveBrand: payload.removeActiveBrand,
    }),
    {
        dataCustomizer: (response, action, store) =>
            action.payload.next ? store.recentOrders.payload.concat(response) : response,
        debounce: 500,
    },
);
